import React from 'react';
import { Box, Heading, Text, Button, Image } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NotFound = () => {
  const logoData = useSelector((state) => state.logoData);
  const logoUrl = logoData?.downloadUrl || "";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="80vh"
      textAlign="center"
      bg="gray.100"
      p={1}
    >
      <Image
        src={logoUrl} 
        alt="404 Not Found"
        mb={6}
        height={300}
      />
      <Heading as="h1" size="2xl" mb={4}>
        Oops! Page Not Found
      </Heading>
      <Text fontSize="lg" mb={6}>
        The page you are looking for does not exist. It might have been removed, or you may have entered the wrong URL.
      </Text>
      <Button
        as={Link}
        to="/"
        colorScheme="teal"
        size="lg"
        variant="solid"
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default NotFound;
